<template>
  <div v-if="isShowRevemtlyViewed" class="recently-viewed-border">
    <div class="recently-viewed-title">Recently Viewed</div>
    <!-- 滚动 -->
    <div class="recently-viewed-data">
      <awesome-swiper
        :pagination="pagination"
        :turnPages="turnPages"
        :swiperData="recentlyViewed"
        :prevName="'recentlyViewed'"
        :nextName="'recentlyViewed'"
      >
        <swiper-slide v-for="(item, index) in list" :key="index">
          <CardCom
            :data="item.recentlyViewedList"
            :type="type"
            :isShowBrandTag="true"
            :isShowAddToCart="false"
            @buryingPoint="buryingPoint">
          </CardCom>
        </swiper-slide>
      </awesome-swiper>
    </div>
  </div>
</template>

<script>
import awesomeSwiper from '../../home/components/awesomeSwiper.vue'
import { swiperSlide } from 'vue-awesome-swiper'
import CardCom from '../../components/card.vue'
import { postAction } from '@/api/manage.js'
export default {
  components: {
    awesomeSwiper,
    swiperSlide,
    CardCom
  },
  props: {
    queryData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    isMobile: {
      type: Array,
      default: function() {
        return {}
      }
    },
    isIpad: {
      type: Array,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      type: 1,
      recentlyViewed: {
        slidesPerView: 5,
        spaceBetween: 20,
        slidesPerGroup: 5,
        loopFillGroupWithBlank: true,
        loop: true
      },
      turnPages: true,
      pagination: true,
      list: [],
      isShowRevemtlyViewed: true,
      limit: 5
    }
  },
  created() {
    if (this.isMobile) {
      this.turnPages = false
      this.limit = 2
      this.recentlyViewed.slidesPerView = 2
      this.recentlyViewed.spaceBetween = 10
      this.recentlyViewed.slidesPerGroup = 2
    }
  },
  methods: {
    buryingPoint(item) {
      let profile = 'staging'
      if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
        profile = 'test'
      } else if (process.env.NODE_ENV === 'production') {
        profile = 'prod'
      }
      const buryingPointObject = {}
      buryingPointObject.productName = item.title
      buryingPointObject.brandName = item.collectionBrandName
      buryingPointObject.productLink = item.seoUrl
      buryingPointObject.productId = item.id
      mixpanel.track(profile + '_recently_viewed_click', buryingPointObject)
    },
    async loadData() {
      const data = {}
      data.sortValue = 7
      data.pageNo = 1
      data.pageSize = 15
      data.searchType = 'recentlyViewed'
      if (this.isMobile) {
        data.pageSize = 16
      }
      if (!this.login) {
        data.macId = localStorage.getItem('mac')
      }
      // 请求品牌下的商品准备
      let res = await postAction('/es/searchGoods', data)
      const arr = []
      this.productTotal = res.result.total
      if (res.result) {
        if (res.result.records && res.result.records.length === 0) {
          this.isShowRevemtlyViewed = false
          return
        }
      }
      res.result.records.map((item) => {
        arr.push({
          ...item,
          ...{
            title: item.title,
            img: item.imgUrl,
            stockNum: item.stockNum || 0,
            totalSales: item.importCount || 0,
            netPrice: item.rrp,
            price: item.wsp
          }
        })
      })
      const resultList = []
      // 按照每凭多少个进行分组,因为不够一屏直接隐藏了，所以这里不需要判断pages 是否大于0
      const pages = arr.length / this.type
      for (var index = 0; index < pages; index++) {
        // 一页一个对象，方便分屏展示
        const recentlyViewedObject = {}
        // 每次从页数 * 每屏个数开始
        const recentlyViewedChildrenList = []
        for (var recentlyViewedObjectIndex = index * this.type; recentlyViewedObjectIndex < (index + 1) * this.type; recentlyViewedObjectIndex++) {
          recentlyViewedChildrenList.push(arr[index])
        }
        recentlyViewedObject.recentlyViewedList = recentlyViewedChildrenList
        resultList.push(recentlyViewedObject)
      }
      this.list = resultList
    }
  }
}
</script>

<style lang="less" scoped>
.recently-viewed-border{
  max-width: 1400px;
  width: 93%;
  margin:0 auto;
  margin-bottom: 20px;
  .recently-viewed-title{
    margin: 34px 0px;
    font-size: 24px;
    font-family: Satoshi-Medium;
    line-height: 32px;
    color: #262613;
    opacity: 1;
    width: 100%;
    display: flex;
  }
}
@media screen and (max-width: 600px) {
  .recently-viewed-border{
    width: 98%;
  }
  .recently-viewed-title{
    justify-content: center;
     margin: 16px 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/detail/recommend/recently-viewed.vue